import React from "react";
import { useTranslation } from "react-i18next";

const btn = {
  display: "inline-block",
  backgroundColor: "#004c3f",
  color: "#fff",
  textDecoration: "none",
  padding: "10px 20px",
  borderRadius: 8,
  fontWeight: 600,
  marginRight: 10,
};

const ContactUsSection = () => {
  const { t } = useTranslation();
  return (
    <section id="contact" style={{ padding: "60px 10%", backgroundColor: "#fff" }}>
      <h2 style={{ fontSize: 26, fontWeight: 700, color: "#0a2750", marginBottom: 10 }}>
        {t("EmiratesMade.Contact.title", { defaultValue: "Contact Us" })}
      </h2>
      <p style={{ color: "#222", lineHeight: 1.7 }}>
        <strong>{t("EmiratesMade.Contact.emailLabel", { defaultValue: "Email:" })}</strong> {t("EmiratesMade.Contact.email", { defaultValue: "To be added" })}
      </p>
      <p style={{ color: "#222", lineHeight: 1.7 }}>
        <strong>{t("EmiratesMade.Contact.phoneLabel", { defaultValue: "Phone:" })}</strong> {t("EmiratesMade.Contact.phone", { defaultValue: "To be added" })}
      </p>
      <p style={{ color: "#222", lineHeight: 1.7, marginBottom: 16 }}>
        <strong>{t("EmiratesMade.Contact.addressLabel", { defaultValue: "Address:" })}</strong> {t("EmiratesMade.Contact.address", { defaultValue: "To be added" })}
      </p>
      <div>
        <a href="#send-message" style={btn}>{t("EmiratesMade.Contact.cta1", { defaultValue: "Send Message" })}</a>
        <a href="#join-movement" style={{ ...btn, backgroundColor: "#0a2750" }}>{t("EmiratesMade.Contact.cta2", { defaultValue: "Join the Movement" })}</a>
      </div>
    </section>
  );
};

export default ContactUsSection;

